import * as React from "react";
const CheveuxM4 = ({ fillColor = "#FFDFC4", strokeColor = "#000000" }) => (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 408 1234">
		<defs>
			<style>
				{`.cls-1 { fill: none; } .cls-2 { stroke-miterlimit: 10; }`}
			</style>
		</defs>
		<title>{"cheveux F 1"}</title>
		<g id="cadre">
			<polygon className="cls-1" points="408 1220 0 1234 0 14 408 0 408 1220" />
		</g>
		<g id="cheveux">
			<path
				id="frame_1_F"
				data-name="frame 1 F"
				className="cls-2"
				fill={fillColor} // 👈 Apply dynamic fill color
				stroke={strokeColor} // 👈 Apply dynamic stroke color
				d="M1025.5,612.5s5,0,7,6,4,18,4,18-15.32-9.31-21.16-22.15c-17.84.15-25.84-18.85-18.25-40.05-6.87-14.62-13.8-28.59-17.59-33.8-2-11,2-32,23-55s77-61,151,3c0,0,14,15-23,15s-57-7-57-7,1,32-21,48c0,16-3,14-5,21s1,16-12,18c-6-13-20-29.39-35-15C984.5,590.5,999.5,623.94,1025.5,612.5Z"
				transform="translate(-878.5 -427.5)"
			/>
		</g>
	</svg>
);
export default CheveuxM4;
